import axios from "./axios";

const Session_AccountId="@AccountId"


//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   console.log(timeLeft);
//   expiredTimer = window.setTimeout(() => {
//     console.log('expired');
//   }, timeLeft);
// };

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
  }
};
const setAccount = (account_id) => {
  if (account_id) {
    localStorage.setItem(Session_AccountId, account_id);
    axios.defaults.headers.AccountId = account_id;
  } else {
    localStorage.removeItem(Session_AccountId);
    delete axios.defaults.headers.AccountId;
  }
};


export {  setSession,setAccount,Session_AccountId };
